$(document).ready(function () {
  console.log("Load action triggered");
  var currentDate = new Date();
  var day = ("0" + currentDate.getDate()).slice(-2);
  var month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
  var year = currentDate.getFullYear();
  console.log(currentDate);

  var formattedDate = month + "/" + day + "/" + year;

  var reldate = document.querySelector("#predead").textContent;
  console.log(reldate);

  var pdinvent = document.querySelector("#pd-invent").textContent;
  console.log(pdinvent);
  let date1 = new Date(reldate);
  let date2 = new Date(formattedDate);
  let Difference_In_Time = date1.getTime() - date2.getTime();

  // Calculating the no. of days between
  let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
  // Appending Specific Text

  if (pdinvent > 0) {
    if (Difference_In_Days >= 14) {
      $(
        '<p style="font-weight:700; color: #e83e2c; margin-bottom: 5px;">Preorder Deadline: ' +
          reldate +
          "</p>"
      ).insertBefore("#expec");
    } else if (Difference_In_Days < 14 && Difference_In_Days > 1) {
      $(
        '<p style="font-weight:700; color: #e83e2c; margin-bottom: 5px;">Act Fast! Only&nbsp;' +
          Difference_In_Days +
          "&nbsp;days left to preorder</p>"
      ).insertBefore("#expec");
    } else if (Difference_In_Days == 1) {
      $(
        '<p style="font-weight:700; color: #e83e2c; margin-bottom: 5px;">Act Now! TOMORROW is the Last Day to Preorder</p>'
      ).insertBefore("#expec");
    } else if (Difference_In_Days == 0) {
      $(
        '<p style="font-weight:700; color: #e83e2c; margin-bottom: 5px;">Act Now! TODAY is the Last Day to Preorder</p>'
      ).insertBefore("#expec");
    } else if (Difference_In_Days < 0) {
      $(
        '<p style="font-weight:700; color: #e83e2c; margin-bottom: 5px;">Preorder NOW for best availability</p>'
      ).insertBefore("#expec");
    } else {
    }
  } else {
    $(
      '<p style="font-weight:700; color: #e83e2c; margin-bottom: 5px;">The preorder window has closed. Existing preorder reservations will be fulfilled once production is complete!</p>'
    ).insertBefore("#expec");
    $(".product-form__add-button").text("Preorder window closed");
  }
  console.log(
    "Total number of days between dates:\n" +
      date1.toDateString() +
      " and " +
      date2.toDateString() +
      " is: " +
      Difference_In_Days +
      " days"
  );
  console.log(formattedDate);
});
